import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-center" }
const _hoisted_5 = {
  class: "modal-title",
  id: "selectionModalLabel"
}
const _hoisted_6 = { class: "row me-5 ms-5 mb-2" }
const _hoisted_7 = { class: "form-group col-5" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.getModalId,
      tabindex: "-1",
      "aria-labelledby": "selectionModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "align-items-center col-7" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectionFulltextFilter) = $event)),
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterSelection(_ctx.selectionFullTextFilter))),
                class: "form-control shadow-none text-black rounded-0",
                placeholder: "Filtr"
              }, null, 544), [
                [_vModelText, _ctx.selectionFulltextFilter]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matrix, (row, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "text-center",
                key: index
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, colIndex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "text-center",
                    key: colIndex
                  }, [
                    _createElementVNode("a", {
                      class: "d-flex justify-content-center dropdown-item d-flex align-items-center fw-bold text-primary",
                      href: "javascript:void(0);",
                      onClick: ($event: any) => (_ctx.handleRedirect(item))
                    }, _toDisplayString((item.propsValue.text != "" && item.propsValue.text != null)?item.propsValue.text.slice(0,13):item.propsValue.value.slice(0,13)), 9, _hoisted_9)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "btn btn-secondary"
            }, "Zrušit")
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}